<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <span>
          <b-img
            fluid
            :src="imgUrlGrsm"
            alt="Login GRSM"
            style="width:30%"
          />
        </span>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
            style="text-align:center"
          >
            <b-img
              fluid
              :src="imgUrlGSencuesta"
              alt="Login GRSM"
              style="width:50%;"
            />
          </b-card-title>
          <b-card-text class="mb-2">
            Bienvenido, ingrese sus credenciales
          </b-card-text>
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Usuario"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Usuario"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="login-username"
                    placeholder="..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>
              <div
                v-if="isBusyLogin"
                class="text-center text-primary my-2"
              >
                <b-spinner
                  variant="primary"
                  class="align-middle"
                />
                <strong class="ml-1">Cargando...</strong>
              </div>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Ingresar
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
    <perfil-select
      :is-busy-modal.sync="isBusyModal"
      :modal-show.sync="modalShow"
      :sistemas.sync="sistemas"
      :token.sync="token"
      :token-type.sync="tokenType"
      :user-data.sync="userData"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BSpinner, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser, getAbilityByRol } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import imgExcel1 from '../../assets/images/encuesta/logo_grsm_m.png'
import imgGsencuesta from '../../assets/images/encuesta/icono-GSEncuestas.jpg'
import PerfilSelect from './Perfil/PerfilSelect.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    // BAlert,
    ValidationProvider,
    ValidationObserver,
    PerfilSelect,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      isBusyLogin: false,
      username: '',
      imgUrlGrsm: imgExcel1,
      imgUrlGSencuesta: imgGsencuesta,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      userData: {},
      modalShow: false,
      sistemaSel: null,
      isBusyModal: false,
      sistemas: [],
      token: '',
      tokenType: '',
      // validation rules
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      this.isBusyLogin = true
      store.dispatch('gsencuesta/AUTH_CREATE_TOKEN', {
        username: this.username,
        password: this.password,
      })
        .then(response => {
          if (response.user.authorities[0].authority !== 'MOVIL') { // && response.user.authorities[0].authority !== 'ENCUESTADOR'
            if (response.sistemas) {
              if (response.sistemas.length > 1) {
                this.modalShow = true
                this.token = response.token
                this.tokenType = response.tokenType
                this.userData = response.user
                this.sistemas = response.sistemas
              } else {
                this.selectedPerfil(response)
              }
            } else {
              this.isBusyLogin = false
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Acceso no Autorizado',
                  icon: 'LockIcon',
                  variant: 'danger',
                  text: 'Lo sentimos no tienes ningún perfil asignado para acceder a la plataforma.',
                },
              })
            }
          } else {
            this.isBusyLogin = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Advertencia', // `Bienvenido ${userData.fullName || userData.username}`,
                icon: 'LockIcon',
                variant: 'warning',
                text: 'Perfil no autorizado para iniciar sesión',
              },
            })
          }

          if (this.sistemaSel != null) {
            const { user } = response
            useJwt.setToken(response.token)
            useJwt.setRefreshToken(response.token)
            localStorage.setItem('userData', JSON.stringify(user))
            this.$ability.update([{ action: 'manage', subject: 'all' }])

            // ? This is just for demo purpose as well.
            // ? Because we are showing eCommerce app's cart items count in navbar
            this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', 5)
            this.$router.push(getHomeRouteForLoggedInUser('admin'))
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Welcome ${user.nombreCompleto}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: `You have successfully logged in as ${user.role}. Now you can start to explore!`,
                  },
                })
              })
              .catch(error => {
                this.isBusyLogin = false
                this.$refs.loginForm.setErrors(error.response.data.error)
              })
          }
        })
        .catch(error => {
          this.isBusyLogin = false
          let errorMessage = 'Intentelo en otro momento.'
          if (error.response) {
            errorMessage = error.response.data.errorMessage
          }
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Ha ocurrido un error',
              icon: 'AlertOctagonIcon',
              variant: 'danger',
              text: errorMessage,
            },
          })
        })
    },
    selectedPerfil(response) {
      let nameProfile = ''
      if (response.user.authorities[0].authority === 'ENCUESTADOR') {
        nameProfile = response.user.authorities[0].authority
        const per = {
          idPerfil: 4,
          nombre: 'ENCUESTADOR',
          estado: true,
        }
        localStorage.setItem('userProfile', JSON.stringify(per))
      } else {
        nameProfile = response.sistemas[0].perfil.nombre
        localStorage.setItem('userProfile', JSON.stringify(response.sistemas[0].perfil))
      }
      this.userData = response.user
      useJwt.setToken(response.token)
      useJwt.setRefreshToken(response.token)
      this.userData.ability = getAbilityByRol(nameProfile)
      localStorage.setItem('userData', JSON.stringify(response.user))
      localStorage.setItem('user-token', response.token) // OPTIMIZAR (TOKEN PARA BACKEND)
      localStorage.setItem('token-type', response.tokenType)
      this.$ability.update(this.userData.ability)
      // ? This is just for demo purpose as well.
      // ? Because we are showing eCommerce app's cart items count in navbar
      this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', 5)
      // console.log(`loging: ${nameProfile}`)
      this.$router.push(getHomeRouteForLoggedInUser(nameProfile))
        .then(() => {
          this.isBusyLogin = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Bienvenido ${this.userData.nombreCompleto}`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `Has iniciado sesión con éxito como ${nameProfile}. Ahora puedes empezar a trabajar!`,
            },
          })
        })
        .catch(() => {
          this.isBusyLogin = false
          // console.log(error)
          // this.$refs.loginForm.setErrors(error.response.data.error)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
